import { EULA_DATA } from "../config/eua_config";

export const EndUserAgreement = () => {
    const data = EULA_DATA
    const { lastUpdated, appName, contactEmail, sections } = data;
    return (
        <article
            className="prose max-w-none"
            style={{
                fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
                lineHeight: 1.6,
            }}
        >
            <h1 style={{ marginBottom: 0 }}>End User Agreement</h1>
            <div style={{ color: "#666", marginBottom: 24 }}>
                <strong>Last Updated:</strong> {lastUpdated}
            </div>

            <p>
                Welcome to <strong>{appName}</strong> (“we,” “our,” or “us”). This End User
                Agreement (“Agreement”) governs your use of our mobile application and related
                services (the “Services”). By accessing or using the Services, you agree to be
                bound by this Agreement. If you do not agree, do not use the Services.
            </p>

            {sections?.map((section, idx) => (
                <section key={section.title + idx} style={{ marginTop: 24 }}>
                    <h2 style={{ fontSize: 20, marginBottom: 8 }}>{section.title}</h2>
                    {section.blocks?.map((block, i) => {
                        if (block.type === "p") {
                            return (
                                <p key={i} style={{ margin: "8px 0" }}>
                                    {block.text}
                                </p>
                            );
                        }
                        if (block.type === "ul") {
                            return (
                                <ul key={i} style={{ paddingLeft: 20, margin: "8px 0" }}>
                                    {block.items?.map((li, j) => (
                                        <li key={j}>{li}</li>
                                    ))}
                                </ul>
                            );
                        }
                        return null;
                    })}
                </section>
            ))}

            <hr style={{ margin: "24px 0" }} />

            <small style={{ color: "#666" }}>
                For support, contact: <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
            </small>
        </article>
    );
}